export type TCopiedMediaItem = {
  id?: string;
  Id?: string;
  fileName?: string;
  Name?: string;
  fileSize?: string | number;
  Size?: string | number;
  duration?: number;
  audioDuration?: number | null;
};

export function normalizeCopiedRepositoryMediaResponse(response: unknown): TCopiedMediaItem[] {
  if (Array.isArray(response)) {
    return response as TCopiedMediaItem[];
  }
  if (response && typeof response === 'object' && 'media' in response) {
    const media = (response as { media?: unknown }).media;
    return Array.isArray(media) ? (media as TCopiedMediaItem[]) : [];
  }
  return [];
}
